<template>
  <div class="project-sum">
    <div class="table-center">
      <el-row class="row-border-1">
        <el-col :span="24" class="padding10">
          <div class="text-center font-weight">
            {{localeValue(competitionSumInfo, competitionNameKey)}}-{{teamInfoVo.teamName}}{{$t('projectSum.registrationForm')}}
          </div>
        </el-col>
      </el-row>
      <!--队伍信息-->
      <el-row class="row-border-1" v-if="teamColumns.length > 0">
              <el-col :span="24" class="padding10 bg-eeecec">
                <div class="text-center font-weight">{{ $t('projectSum.teamInfo') }}</div>
              </el-col>
            </el-row>
            <el-row class="row-border-1" v-if="teamColumns.length > 0">
              <el-col v-for="(col, index) in teamColumns" :key="col.key" :span="col.span"
                      :class="index === 0 ? 'padding10' : 'cell-border-f padding10'">
                <div class="text-center font-weight">{{ col.label }}</div>
              </el-col>
            </el-row>
            <el-row class="row-border-1" v-if="teamColumns.length > 0">
              <el-col v-for="(col, index) in teamColumns" :key="col.key + '-value'" :span="col.span"
                      :class="index === 0 ? 'padding10' : 'cell-border-f padding10'">
                <div class="text-center word-break">{{ teamInfoVo[col.prop] }}</div>
              </el-col>
            </el-row>
            <!--运动员信息-->
      <el-row class="row-border-1" v-if="athleteColumns.length > 0">
        <el-col :span="24" class="padding10 bg-eeecec">
          <div class="text-center font-weight">{{ $t('projectSum.athleteInfo') }}</div>
        </el-col>
      </el-row>
      <el-row class="row-border-1" v-if="athleteColumns.length > 0">
        <el-col v-for="(col, index) in athleteColumns" :key="col.key" :span="col.span"
                :class="index === 0 ? 'padding10' : 'cell-border-f padding10'">
          <div class="text-center font-weight">{{ col.label }}</div>
        </el-col>
      </el-row>
      <div v-for="athlete in competitionSumInfo.athleteList" :key="athlete.id">
        <el-row class="row-border-1">
          <el-col v-for="(col, index) in athleteColumns" :key="col.key" :span="col.span"
                  :class="index === 0 ? '' : 'cell-border-f'">
            <div class="text-center cell-image">
              <!-- 原生img：加载中即存在于DOM，waitForImages 可真实等待，避免打印缺图 -->
              <img v-if="col.type === 'image' && athlete[col.prop]"
                   :src="define.previewNginxUrl + athlete[col.prop]"
                   style="width: auto; height: 40px">
              <span v-else>{{ formatCellValue(athlete, col) }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <!--随队官员-->
      <el-row class="row-border-1" v-if="personColumns.length > 0">
        <el-col :span="24" class="padding10 bg-eeecec">
          <div class="text-center font-weight">{{ $t('projectSum.officialInfo') }}</div>
        </el-col>
      </el-row>
      <el-row class="row-border-1" v-if="personColumns.length > 0">
        <el-col v-for="(col, index) in personColumns" :key="col.key" :span="col.span"
                :class="index === 0 ? 'padding10' : 'cell-border-f padding10'">
          <div class="text-center font-weight">{{ col.label }}</div>
        </el-col>
      </el-row>
      <div v-for="person in competitionSumInfo.personList" :key="person.id">
        <el-row class="row-border-1">
          <el-col v-for="(col, index) in personColumns" :key="col.key" :span="col.span"
                  :class="index === 0 ? '' : 'cell-border-f'">
            <div class="text-center cell-image">
              <img v-if="col.type === 'image' && person[col.prop]"
                   :src="define.previewNginxUrl + person[col.prop]"
                   style="width: auto; height: 40px">
              <span v-else>{{ formatCellValue(person, col) }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <!--个人项目-->
      <template v-if="showProjectType('1')">
        <el-row class="row-border-1">
          <el-col :span="24" class="padding10 bg-eeecec">
            <div class="text-center font-weight">{{ $t('common.individualProject') }}</div>
          </el-col>
        </el-row>
        <div v-for="(personProjects, key) in competitionSumInfo.personProjectList" :key="'personProject-' + key">
          <el-row class="row-border-1">
            <el-col :span="5" class="padding10">
              <div class="text-center">{{localeValue(personProjects, projectNameKey)}}</div>
            </el-col>
            <el-col :span="19" class="cell-border-f padding10">
              <div class="">
                <span v-for="(personProject, index) in personProjects.teamAthleteList" :key="personProject.id">
                  <span v-if="index === 0">{{localeValue(personProject, competitionAthleteNameKey)}}</span>
                  <span v-else>、{{localeValue(personProject, competitionAthleteNameKey)}}</span>
                   <span v-if="personProject.description">（{{ remarkLabel }}：{{personProject.description}}）</span>
                </span>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
      <!--集体项目-->
      <template v-if="showProjectType('2')">
        <el-row class="row-border-1">
          <el-col :span="24" class="padding10 bg-eeecec">
            <div class="text-center font-weight">{{ $t('common.groupProject') }}</div>
          </el-col>
        </el-row>
        <div v-for="(teamProjects, key) in competitionSumInfo.teamProjectList" :key="'teamProject-' + key">
          <el-row class="row-border-1">
            <el-col :span="5" class="padding10">
              <div class="text-center">{{localeValue(teamProjects, projectNameKey)}}</div>
            </el-col>
            <el-col :span="19" class="cell-border-f padding10">
              <div class="">
                <span v-for="(teamProject, index) in teamProjects.teamAthleteList" :key="teamProject.id">
                  <span v-if="index === 0">{{localeValue(teamProject, competitionAthleteNameKey)}}{{localeValue(teamProject, itemPositionNameKey) ? '（' + $t('common.position') + '：' + localeValue(teamProject, itemPositionNameKey) + '）' : ''}}{{teamProject.substitution === 1 ? '（' + $t('common.substitute') + '）' : ''}}</span>
                  <span v-else>、{{localeValue(teamProject, competitionAthleteNameKey)}}{{localeValue(teamProject, itemPositionNameKey) ? '（' + $t('common.position') + '：' + localeValue(teamProject, itemPositionNameKey) + '）' : ''}}{{teamProject.substitution === 1 ? '（' + $t('common.substitute') + '）' : ''}}</span>
                </span>
                <span v-if="teamProjects.teamAthleteList[0] && teamProjects.teamAthleteList[0].description">（{{ remarkLabel }}：{{ teamProjects.teamAthleteList[0].description}}）</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
      <!--对练项目-->
      <template v-if="showProjectType('3')">
        <el-row class="row-border-1">
          <el-col :span="24" class="padding10 bg-eeecec">
            <div class="text-center font-weight">{{ $t('common.pairTrainingProject') }}</div>
          </el-col>
        </el-row>
        <div v-for="(trainProjects, key) in competitionSumInfo.trainProjectList" :key="'trainProject-' + key">
          <el-row class="row-border-1">
            <el-col :span="5" class="padding10">
              <div class="text-center">{{localeValue(trainProjects, projectNameKey)}}</div>
            </el-col>
            <el-col :span="19" class="cell-border-f padding10">
              <div class="">
                <div v-for="(trainValue, trainKey, index) in trainProjects.trainAthleteList" :key="trainKey">
                  {{index+1}}、
                  <span v-for="(trainItem, index) in trainValue" :key="trainItem.id" style="width: 100%">
                    <span v-if="index === 0">{{localeValue(trainItem, competitionAthleteNameKey)}}</span>
                    <span v-else>、{{localeValue(trainItem, competitionAthleteNameKey)}}</span>
                    <span v-if="trainItem.practice === 1">（{{ $t('common.trainingPartner') }}）</span>
                  </span>
                  <span v-if="trainValue[0] && trainValue[0].description">（{{ remarkLabel }}：{{trainValue[0].description }}）</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
      <!--统计信息-->
      <el-row class="row-border-1">
        <el-col :span="24" class="padding10 bg-eeecec">
          <div class="text-center font-weight">{{ $t('common.statistics') }}</div>
        </el-col>
      </el-row>
      <el-row class="row-border-1">
        <el-col :span="4" class="padding10">
          <div class="text-center font-weight">{{ $t('common.totalPeople') }}</div>
        </el-col>
        <el-col :span="4" class="cell-border-f padding10">
          <div class="text-center font-weight">{{ $t('common.male') }}</div>
        </el-col>
        <el-col :span="4" class="cell-border-f padding10">
          <div class="text-center font-weight">{{ $t('common.female') }}</div>
        </el-col>
        <el-col :span="4" class="cell-border-f padding10">
          <div class="text-center font-weight">{{ $t('common.athlete') }}</div>
        </el-col>
        <el-col :span="4" class="cell-border-f padding10">
          <div class="text-center font-weight">{{ $t('common.maleAthlete') }}</div>
        </el-col>
        <el-col :span="4" class="cell-border-f padding10">
          <div class="text-center font-weight">{{ $t('common.femaleAthlete') }}</div>
        </el-col>
      </el-row>
      <el-row class="row-border-1">
        <el-col :span="4" class="cell-border-b padding10">
          <div class="text-center">{{personStaVo.sumNum}} {{$t('common.people')}}</div>
        </el-col>
        <el-col :span="4" class="cell-border-fb padding10">
          <div class="text-center">{{personStaVo.maleNum}} {{$t('common.people')}}</div>
        </el-col>
        <el-col :span="4" class="cell-border-fb padding10">
          <div class="text-center">{{personStaVo.femaleNum}} {{$t('common.people')}}</div>
        </el-col>
        <el-col :span="4" class="cell-border-fb padding10">
          <div class="text-center">{{personStaVo.athleteNum}} {{$t('common.people')}}</div>
        </el-col>
        <el-col :span="4" class="cell-border-fb padding10">
          <div class="text-center">{{personStaVo.maleAthleteNum}} {{$t('common.people')}}</div>
        </el-col>
        <el-col :span="4" class="cell-border-fb padding10">
          <div class="text-center">{{personStaVo.femaleAthleteNum}} {{$t('common.people')}}</div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import {competitionSumInfo} from "@/api/competition";
import {getCompetitionFormConfigInfo} from "@/api/competitionFormConfig";
export default {
  name: "print-pdf",
  computed: {
    // 备注标题（报项表单配置，留空默认备注）
    remarkLabel() {
      const remarkLabel = (this.competitionFormConfigInfo.projectForm || {}).remarkLabel;
      return remarkLabel || this.$t('common.comment');
    },
    // 赛事名称中英文
    competitionNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'nameCh' : 'nameEn';
    },
    // 赛事组别名称中英文
    competitionGroupNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'groupNameCh' : 'groupNameEn';
    },
    // 赛事小项名称中英文
    competitionItemNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'itemNameCh' : 'itemNameEn';
    },
    // 赛事运动员姓名中英文
    competitionAthleteNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'athleteRealNameCh' : 'athleteRealNameEn';
    },
    // 集体项目运动员职位名称中英文
    itemPositionNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'itemPositionNameCh' : 'itemPositionNameEn';
    },
    // 项目名称中英文
    projectNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'nameCh' : 'nameEn';
    },
    // 赛事职能名称中英文
    competitionFunctionNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'functionNameCh' : 'functionNameEn';
    },
    // 显示项目类型区块（1=个人项目 2=集体项目 3=对练项目）
    showProjectType() {
      return (fieldType) => {
        const competitionForm = this.competitionFormConfigInfo.competitionForm;
        if (!competitionForm) return false;
        const fieldConfig = competitionForm.projectTypeJson;
        return fieldConfig && fieldConfig.checkedOptions && fieldConfig.checkedOptions.includes(fieldType);
      };
    },
    // 运动员字段标签
    labelAthleteField() {
      return (fieldName) => {
        const fieldConfig = (this.competitionFormConfigInfo.athleteForm || {})[fieldName];
        return fieldConfig && fieldConfig.label;
      };
    },
    // 随队官员字段标签
    labelPersonField() {
      return (fieldName) => {
        const fieldConfig = (this.competitionFormConfigInfo.personForm || {})[fieldName];
        return fieldConfig && fieldConfig.label;
      };
    },
    // 代表队信息动态列（显示/隐藏、汇总表宽度取自队伍表单配置）
    teamColumns() {
      const defs = [
        {key: 'realNameJson', prop: 'realName', label: this.$t('teamInfo.contactName')},
        {key: 'mobileJson', prop: 'mobile', label: this.$t('common.contactPhone')},
        {key: 'emailJson', prop: 'email', label: this.$t('common.contactEmail')},
        {key: 'memberUnitJson', prop: 'memberUnitNameCh', label: this.$t('teamInfo.memberUnit')},
        {key: 'regionJson', prop: 'regionNameCh', label: this.$t('teamInfo.region')},
      ];
      return this.summaryColumns('teamForm', defs);
    },
    // 运动员信息动态列（显示/隐藏、汇总表宽度取自运动员表单配置）
    athleteColumns() {
      const defs = [
        {key: 'realNameChJson', prop: 'realNameCh', label: this.labelAthleteField('realNameChJson')},
        {key: 'realNameEnJson', prop: 'realNameEn', label: this.$t('athleteInfo.realNameEn')},
        {key: 'familyNameChJson', prop: 'familyNameCh', label: this.$t('athleteInfo.surnameCh')},
        {key: 'familyNameEnJson', prop: 'familyNameEn', label: this.$t('athleteInfo.surnameEn')},
        {key: 'givenNameChJson', prop: 'givenNameCh', label: this.$t('athleteInfo.givenNameCh')},
        {key: 'givenNameEnJson', prop: 'givenNameEn', label: this.$t('athleteInfo.givenNameEn')},
        {key: 'certificateTypeJson', prop: 'certificateType', label: this.$t('common.certificateType'), type: 'certificateType'},
        {key: 'certificateNumberJson', prop: 'certificateNumber', label: this.$t('common.certificateNumber')},
        {key: 'genderJson', prop: 'gender', label: this.$t('common.gender'), type: 'gender'},
        {key: 'ageJson', prop: 'age', label: this.$t('common.age')},
        {key: 'birthdayJson', prop: 'birthday', label: this.$t('common.birthDate')},
        {key: 'groupJson', prop: this.competitionGroupNameKey, label: this.$t('common.group')},
        {key: 'headIconJson', prop: 'headIcon', label: this.$t('common.headPhoto'), type: 'image'},
        {key: 'certificateFrontalPhotoJson', prop: 'certificateFrontalPhoto', label: this.$t('common.certificateFrontPhoto'), type: 'image'},
        {key: 'certificateReversePhotoJson', prop: 'certificateReversePhoto', label: this.$t('common.certificateBackPhoto'), type: 'image'},
        {key: 'mobileJson', prop: 'mobile', label: this.$t('common.contactPhone')},
        {key: 'emailJson', prop: 'email', label: this.$t('common.contactEmail')},
        {key: 'customText1Json', prop: 'customText1', label: this.labelAthleteField('customText1Json')},
        {key: 'customText2Json', prop: 'customText2', label: this.labelAthleteField('customText2Json')},
        {key: 'customText3Json', prop: 'customText3', label: this.labelAthleteField('customText3Json')},
        {key: 'customFile1Json', prop: 'customFile1', label: this.labelAthleteField('customFile1Json'), type: 'image'},
        {key: 'customFile2Json', prop: 'customFile2', label: this.labelAthleteField('customFile2Json'), type: 'image'},
        {key: 'customFile3Json', prop: 'customFile3', label: this.labelAthleteField('customFile3Json'), type: 'image'},
      ];
      return this.summaryColumns('athleteForm', defs);
    },
    // 随队官员信息动态列（显示/隐藏、汇总表宽度取自随队官员表单配置）
    personColumns() {
      const defs = [
        {key: 'realNameChJson', prop: 'realNameCh', label: this.labelPersonField('realNameChJson')},
        {key: 'realNameEnJson', prop: 'realNameEn', label: this.$t('personInfo.realNameEn')},
        {key: 'familyNameChJson', prop: 'familyNameCh', label: this.$t('personInfo.surnameCh')},
        {key: 'familyNameEnJson', prop: 'familyNameEn', label: this.$t('personInfo.surnameEn')},
        {key: 'givenNameChJson', prop: 'givenNameCh', label: this.$t('personInfo.givenNameCh')},
        {key: 'givenNameEnJson', prop: 'givenNameEn', label: this.$t('personInfo.givenNameEn')},
        {key: 'certificateTypeJson', prop: 'certificateType', label: this.$t('common.certificateType'), type: 'certificateType'},
        {key: 'certificateNumberJson', prop: 'certificateNumber', label: this.$t('common.certificateNumber')},
        {key: 'genderJson', prop: 'gender', label: this.$t('common.gender'), type: 'gender'},
        {key: 'ageJson', prop: 'age', label: this.$t('common.age')},
        {key: 'birthdayJson', prop: 'birthday', label: this.$t('common.birthDate')},
        {key: 'groupJson', prop: this.competitionGroupNameKey, label: this.$t('common.group')},
        {key: 'itemJson', prop: this.competitionItemNameKey, label: this.$t('common.item')},
        {key: 'headIconJson', prop: 'headIcon', label: this.$t('common.headPhoto'), type: 'image'},
        {key: 'certificateFrontalPhotoJson', prop: 'certificateFrontalPhoto', label: this.$t('common.certificateFrontPhoto'), type: 'image'},
        {key: 'certificateReversePhotoJson', prop: 'certificateReversePhoto', label: this.$t('common.certificateBackPhoto'), type: 'image'},
        {key: 'mobileJson', prop: 'mobile', label: this.$t('common.contactPhone')},
        {key: 'emailJson', prop: 'email', label: this.$t('common.contactEmail')},
        {key: 'functionJson', prop: this.competitionFunctionNameKey, label: this.$t('common.function')},
        {key: 'customText1Json', prop: 'customText1', label: this.labelPersonField('customText1Json')},
        {key: 'customText2Json', prop: 'customText2', label: this.labelPersonField('customText2Json')},
        {key: 'customText3Json', prop: 'customText3', label: this.labelPersonField('customText3Json')},
        {key: 'customFile1Json', prop: 'customFile1', label: this.labelPersonField('customFile1Json'), type: 'image'},
        {key: 'customFile2Json', prop: 'customFile2', label: this.labelPersonField('customFile2Json'), type: 'image'},
        {key: 'customFile3Json', prop: 'customFile3', label: this.labelPersonField('customFile3Json'), type: 'image'},
      ];
      return this.summaryColumns('personForm', defs);
    },
  },
  data() {
    return {
      // 汇总信息
      competitionSumInfo: {},
      // 代表队信息
      teamInfoVo: {},
      // 汇总统计
      personStaVo: {},
      // 赛事表单配置信息
      competitionFormConfigInfo: {},
      // 汇总信息是否加载完成
      sumInfoLoaded: false,
      // 表单配置是否加载完成
      configLoaded: false,
      // 查询参数
      params: {
        // 赛事ID
        competitionId: '',
        // 类型
        type: '',
        // 用户ID
        userId: ''
      }
    };
  },
  watch: {},
  created() {
    let id = this.$route.query.id;
    if (!id) {
      this.$router.push({ path: "/index" });
    } else {
      this.params.competitionId = id;
      this.params.type = this.$route.query.type;
      this.params.userId = this.$route.query.userId;
    }
  },
  mounted() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/login?id=" + this.params.competitionId });
    } else {
      this.findCompetitionSumInfo();
      this.findCompetitionFormConfigInfo();
    }
  },
  methods: {
    // 获取赛事信息
    findCompetitionSumInfo(){
      competitionSumInfo(this.params).then((res) => {
        this.competitionSumInfo = res.data;
        this.teamInfoVo = res.data.teamInfoVo;
        this.personStaVo = res.data.personStaVo;
        this.sumInfoLoaded = true;
        this.tryPrint();
      });
    },
    // 获取赛事表单配置信息
    findCompetitionFormConfigInfo(){
      getCompetitionFormConfigInfo(this.params.competitionId).then((res) => {
        this.competitionFormConfigInfo = res.data || {};
      }).finally(() => {
        this.configLoaded = true;
        this.tryPrint();
      });
    },
    // 汇总信息与表单配置都加载完成后调起打印
    tryPrint(){
      if (!this.sumInfoLoaded || !this.configLoaded) return;
      this.$nextTick(() => {
        this.waitForImages().then(() => {
          setTimeout(() => {
            window.print();
          }, 200);
        });
      });
    },
    // 等待页面内所有图片加载完成（或失败）后再打印，避免打印快照缺图、行高塌陷，最长等待10秒
    waitForImages(){
      const images = Array.prototype.slice.call(this.$el.querySelectorAll('img'));
      const tasks = images.map(img => {
        if (img.complete) return Promise.resolve();
        return new Promise(resolve => {
          img.addEventListener('load', resolve, {once: true});
          img.addEventListener('error', resolve, {once: true});
        });
      });
      const timeout = new Promise(resolve => setTimeout(resolve, 10000));
      return Promise.race([Promise.all(tasks), timeout]);
    },
    // 根据表单配置生成汇总表动态列（isShow控制显示，span为汇总表宽度）
    summaryColumns(formName, defs) {
      const formConfig = this.competitionFormConfigInfo[formName] || {};
      const columns = [];
      defs.forEach(def => {
        const fieldConfig = formConfig[def.key];
        if (fieldConfig && fieldConfig.isShow === 1) {
          columns.push({
            key: def.key,
            prop: def.prop,
            label: def.label,
            type: def.type || 'text',
            span: fieldConfig.span && fieldConfig.span > 0 ? fieldConfig.span : 4, // span未配置或为0时按1/6宽度兜底，避免列被压没
          });
        }
      });
      return columns;
    },
    // 汇总表单元格文本
    formatCellValue(row, col) {
      const value = this.localeValue(row, col.prop);
      if (col.type === 'gender') {
        return value === 1 ? this.$t('common.male') : this.$t('common.female');
      }
      if (col.type === 'certificateType') {
        return this.certificateTypeText(value);
      }
      return value === null || value === undefined ? '' : value;
    },
    // 证件类型文本
    certificateTypeText(value) {
      const labelMap = {
        1: 'common.idCard',
        2: 'common.drivingLicense',
        3: 'common.passport',
        4: 'common.militaryCard',
        5: 'common.hkMacauId',
        6: 'common.taiwanPermit',
        7: 'common.other'
      };
      return labelMap[value] ? this.$t(labelMap[value]) : '';
    },
  },
};
</script>
<style lang="scss" scoped>

.project-sum{
  width: 100%;

  .table-center {
    height: calc(100vh - 300px);
    width: 99%;
    margin: 0 auto;

    .row-border-1 {
      display: flex;
      // 列拉伸到整行高，竖向边框才不会被换行撑高的行截短；列内用flex保持内容垂直居中
      align-items: stretch;
      flex-wrap: wrap;
      border-top: 1px solid #dcdcdc;
      border-left: 1px solid #dcdcdc;
      border-right: 1px solid #dcdcdc;
      transition: background-color 0.15s;

      > .el-col {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }

    .cell-border-f {
      border-left: 1px solid #dcdcdc;
      box-sizing: border-box;
    }

    .cell-border-fb {
      border-left: 1px solid #dcdcdc;
      border-bottom: 1px solid #dcdcdc;
      box-sizing: border-box;
    }

    .cell-border-b {
      border-bottom: 1px solid #dcdcdc;
      box-sizing: border-box;
    }

    .text-center{
      text-align: center;
    }

    .font-weight {
      font-weight: bold;
      color: #303133;
    }

    .word-break{
      word-break: break-all;
    }

    .cell-image{
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50px;
      word-break: break-all;
    }

    .padding10 {
      padding: 10px;
    }

    .bg-eeecec {
      background: #f0f2f5;
      padding: 12px 10px;
      border-left: 4px solid #409eff;
    }
  }

  // 打印修正：flex行在分页处会被切断导致边框丢失、布局错乱，禁止行内部分页
  @media print {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;

    .table-center {
      height: auto;
    }

    .row-border-1 {
      break-inside: avoid;
      page-break-inside: avoid;
    }
  }
}
</style>
